import { collectionListItem } from '~/types/pdfCollection/collectionCategories'

export default {
  [collectionListItem.DETAILS]: 'Details',
  [collectionListItem.SCREENREADER_DETAILS]: '{name} Produktseite',
}
